import React from 'react';
export function Header() {
  return <header className="sticky top-0 z-40 bg-ivory/95 backdrop-blur border-b border-ink/10" data-id="element-81" data-mp="1l9wls241gi3n">
      <a href="#contenuto" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-3 focus:z-50 focus:bg-ivory focus:px-4 focus:py-2 focus:text-sm focus:font-semibold" data-id="element-82" data-mp="2dn5uypywytkf">
        Vai al contenuto
      </a>
      
    </header>;
}